<section class="madar--v2">
<mat-card class="card--bordered">
  <mat-card-content>
    <mat-card-header class="card-header--divided">
      <div class="flex justify-space-between row">
        <span class="weight-medium h6 m-0 text-900">{{ "Customers.Locations.LocationsList" | translate }}</span>
  
        <div *ngIf="(RolesConstants.CUSTOMER_EDIT | userRoleChecker) && !readOnly" (click)="onAddMoreLocations()"  class="add-locations">
          <img class="mx-2" src="assets/images/add-icon.svg" />
          <span *ngIf="locations?.length">{{'Location.AddMoreLocations' | translate}}</span>
          <span *ngIf="!locations?.length">{{'Location.AddLocation' | translate}}</span>
        </div>
      </div>
    </mat-card-header>

    <section class="locations-list-wrapper mt-0">
      <app-entity-listing
        [totalCount]="totalRowsCount"
        [state]="sectionState"
        [pageIndex]="filters.params.offset + 1"
        [pageSize]="filters.params.limit"
        [emptyStateMainLabel]="'Customers.Locations.emptyStateMainLabel' | translate"
        [emptyStateSubLabel]="'Customers.Locations.emptyStateSubLabel' | translate"
        [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
        (pageIndexChange)="filters.params = { offset: $event - 1 }"
        (pageSizeChange)="filters.params = { limit: $event, offset: 0 }"
      >
        <table  class="table scrollable scrollable--x" mat-table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="defaultIcon">
            <th mat-header-cell *matHeaderCellDef  [hidden]="!showAddLocationTypeColumn"></th>
            <td mat-cell *matCellDef="let location" [hidden]="!showAddLocationTypeColumn">
              <img *ngIf="location.isDefault" src="/assets/images/default-icon.svg" [matTooltip]=" 'Location.DefaultLocation' | translate">
              <img *ngIf="!location.isDefault" src="/assets/images/regular-icon.svg">
              <img>
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef  [hidden]="!showAddLocationTypeColumn">{{ "Customers.Locations.Type" | translate }}</th>
            <td mat-cell *matCellDef="let location" [hidden]="!showAddLocationTypeColumn">
              <div>{{ 'Enum.AddLocationType.' + location?.locationType | translate }}</div>
            </td>
          </ng-container> -->

          <ng-container matColumnDef="locationName">
            <th mat-header-cell *matHeaderCellDef >{{ "Customers.Locations.Name" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div>{{ location?.title||'_______' }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef >{{ "Customers.Locations.City" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div>{{ location?.city?.name ||'_______' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="Latitude&Longitude">
            <th mat-header-cell *matHeaderCellDef >{{ "Customers.Locations.Lat&Long" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div>{{ location?.latitude }}, {{location?.longitude}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef >{{ "Customers.Locations.Address" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <div class="tooltip">
                <div class="limited-text">
                  {{ location?.address ||'_______' }}
                </div>
                <div class="tooltiptext text-bold">
                  {{ location?.address ||'_______' }}
                </div>
              </div>

            </td>
          </ng-container>

          <ng-container matColumnDef="shippingType">
            <th mat-header-cell *matHeaderCellDef >{{ "Inputs.ShippingType" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              {{ ("Enum.ShippingType." + location.shippingType | translate) || "_____" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="contacts">
            <th mat-header-cell *matHeaderCellDef >{{ "Location.Labels.Contacts" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <ng-container *ngIf="location.usersLocations?.length">
              <div class="tooltip">
                  <div *ngFor="let userLocation of location.usersLocations; let i = index">
                    <div *ngIf="i < 3" class="list">
                      <div class="list__text">{{ userLocation.user?.firstName + '-' + userLocation.user?.lastName }}</div>
                      <div *ngIf="i == 2 && location.usersLocations.length - 3 > 0" class="list__count">+ {{ location.usersLocations.length - 3 }}</div>
                    </div>
                  </div>
                  <div class="tooltiptext">
                    <ul class="px-2 my-0">
                      <li *ngFor="let userLocation of location.usersLocations" class="mb-1 text-bold" >
                        {{ userLocation.user?.firstName + '-' + userLocation.user?.lastName }}
                      </li>
                    </ul>
                  </div>
              </div>

              </ng-container>
              <ng-container *ngIf="!location.usersLocations?.length">
                _______
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ "Customers.Table.Status" | translate }}</th>
            <td mat-cell *matCellDef="let location">
              <app-rect-tag *ngIf="location.status" [color]="location?.status === LocationStatus.Active ? 'success' : 'default'">{{ 'Enum.Status.' + location?.status | translate}}</app-rect-tag>
              <div *ngIf="!location.status">{{ '_____' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th class="center" mat-header-cell *matHeaderCellDef >{{ "Customers.Table.Actions" | translate }}</th>

            <td [matMenuTriggerFor]="menu" class="center action" mat-cell *matCellDef="let location" app-click-stop-propagation>
              <div class="flex justify-center align-center">
                <div class="flex justify-center">
                  <app-icon name="menu-vert"  class="cursor-pointer text-700"></app-icon>
                </div>

                <mat-menu class="item-actions" #menu>
                  <mat-option *ngIf="(RolesConstants.LOCATION_STATUS_EDIT  | userRoleChecker)" (click)="onChangeStatus(location)">
                    <span>{{ (location?.status === LocationStatus.Active ?  "Location.Deactivate" : "Location.Activate") | translate }}</span>
                  </mat-option>

                  <mat-option (click)="onNavigateToMap(location)" *ngIf="location.locationType !== AddLocationType.Customer">
                    <span>{{ "Customers.Locations.ShowOnMap" | translate }}</span>
                  </mat-option>

                  <mat-option (click)="onSetAsDefault(location)" *ngIf="(location.locationType !== AddLocationType.Customer) && !readOnly && !location.isDefault && !(customerLabel === companyLabelType.Ycc || customerLabel === companyLabelType.YccCustomer)">
                    <span>{{ "Location.SetAsDefault" | translate }}</span>
                  </mat-option>
                  <mat-option (click)="onSelectLocation(location); matDialog.open(addLocationModal)"
                  *ngIf="((location.locationType !== AddLocationType.Customer) && !readOnly && !isMyCustomersView ) ||  (isMyCustomersView && parentId === location.createdByCustomer)">
                    <span>{{ "Buttons.Edit" | translate }}</span>
                  </mat-option>

                  <mat-option
                  [routerLink]="RoutesUtil.LocationCustomerView.url({ id: location.id })"
                  *ngIf="location.locationType === AddLocationType.Customer"
                >
                  <span>{{ "Buttons.Details" | translate }}</span>
                </mat-option>


                </mat-menu>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onNavigateToMap(row)"></tr>
        </table>
      </app-entity-listing>
    </section>
  </mat-card-content>
</mat-card>
</section>


<ng-template #addLocationModal>
  <app-dialog-layout class="dialog-layout madar--v2">
    <ng-container dialog-title>{{ (selectedLocation?.id ? 'Location.EditLocation' : 'Location.AddLocation') | translate }}</ng-container>
    <div dialog-content class="mt-3">
      <app-add-location
        (closeModal)="matDialog?.closeAll()"
        (reloadComponent)="reload.emit();"
        (updatedLocation)="onUpdateLocation($event)"
        (locationId)="onAddLocation($event)"
        [item]="item"
        [location]="selectedLocation"
        [type]="type"
      ></app-add-location>
    </div>
  </app-dialog-layout>
</ng-template>
